import { useQuery } from '@tanstack/react-query';

import { ReportType, MetadataClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const metaDataClient = new MetadataClient(apiBaseUrl);

function useGetFormColor(reportType: ReportType) {
  return useQuery({
    queryKey: [queryKeys.Metadata.FormName, { reportType }],
    queryFn: () => metaDataClient.getFormColor(reportType),
  });
}

export default useGetFormColor;
